import { render } from "./GlobeIcon.vue?vue&type=template&id=375347a6&scoped=true"
const script = {}

import "./GlobeIcon.vue?vue&type=style&index=0&id=375347a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-375347a6"]])

export default __exports__